export default __webpack_public_path__ + "f9ee12f727263947f9569678930beeb5.woff";